/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_152c2006","_152c2006",""]'><div :class='["","_152c2006",""]'><cube-button @_click="showPicker" :class='["","_152c2006",""]'>slot-Picker</cube-button><cube-date-picker-modal ref="__mpx_ref_picker__" title="标题" :min="(min)" :max="(max)" :value="(value)" :format="(format)" :columnOrder="(columnOrder)" :class='["","_152c2006",""]'><div slot="header" :class='["demo-slot-header-wrapper","_152c2006",""]'><mpx-image src="https://ut-static.udache.com/webx/mpx-cube-ui/1GyZ1gVbkoNIDOtGNwyUh.jpg" :style='["background-size: 100%"] | transRpxStyle' :class='["demo-slot-header","_152c2006",""]'></mpx-image></div><div slot="footer" @tap='(e)=>__invoke(e, [["clickCustomBtn"]])' :class='["demo-slot-footer","_152c2006",""]'>时间不在范围内</div></cube-date-picker-modal></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_152c2006"}'>
.demo-slot-header-wrapper
  margin-bottom: 10px
  font-size: 0px
.demo-slot-header
  width 100%
  height 170px
.demo-slot-footer
  margin-top 15px
  text-align center
  font-size 16px
  color #757575
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_152c2006"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_152c2006"}
  /** script content **/
  require("./slot-picker.mpx.js?isComponent&outputPath=components%2Fslot-picker152c2006%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./slot-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fslot-picker152c2006%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_152c2006"],
    ctorType: "component",
    outputPath: "components/slot-picker152c2006/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker-modal/index.mpx?isComponent&outputPath=components%2Findex5001a0cc%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>